import { INodeMapping, IVersionMappingUpdate } from '../tree/TreeActions'
import { INode } from 'shared/types/tree'
import * as React from 'react'
import { findBestMatch, NodeIdMap } from './utility'
import { Box, Button, TextField } from '@mui/material'
import { goToNode } from '../masters_management/utility'
import { ConfirmCommitButton } from 'shared/ui'

export function SingleMapping({
  mapping,
  source,
  destinationMap,
  updateMappingFunc,
  destinationTree,
  sourceTree,
}: {
  mapping: INodeMapping
  source: { node: INode; path: string }
  destinationMap: NodeIdMap
  updateMappingFunc: (updateInfo: IVersionMappingUpdate) => void
  destinationTree: INode
  sourceTree: INode
}) {
  const [toNode, setToNode] = React.useState<INode | undefined>()
  const [overrideId, setOverrideId] = React.useState('')
  const [overrideNode, setOverrideNode] = React.useState<INode>()

  React.useEffect(() => {
    const match = findBestMatch({
      path: source.path,
      destTree: destinationTree,
      sourceTree,
    })
    if (match) {
      setToNode(match)
    }
  }, [source, destinationTree, sourceTree])

  React.useEffect(() => {
    setOverrideNode(destinationMap[overrideId]?.node)
  }, [destinationMap, overrideId])

  function updateMapping() {
    const to_node_id = overrideNode?.id || toNode?.id
    if (!to_node_id) return
    updateMappingFunc({ id: mapping.id, deleted: false, to_node_id })
    setOverrideId('')
  }

  function deleteMapping() {
    updateMappingFunc({ id: mapping.id, deleted: true, to_node_id: '' })
    setOverrideId('')
  }

  return (
    <Box>
      <Box padding={'10px'}>
        <Box>Current Node To Map</Box>
        <Box>{mapping.from_node_id}</Box>
        <Box>Deleted: {mapping.deleted.toString()}</Box>
      </Box>
      <Box padding={'5px'}>
        <TextField
          value={overrideId}
          onChange={({ target: { value } }) => setOverrideId(value)}
        />
        <Box padding={'5px'} border={'solid 1px'}>
          <NodeCompare
            source={source}
            dest={
              toNode && {
                node: toNode,
                path: destinationMap[toNode.id].treePath,
              }
            }
            override={
              overrideNode && {
                node: overrideNode,
                path: destinationMap[overrideNode.id].treePath,
              }
            }
          />
          <ConfirmCommitButton
            disabled={!toNode && !overrideNode}
            onClick={updateMapping}
          >
            <>
              {overrideNode
                ? 'Confirm Mapping with Override'
                : 'Confirm Mapping'}
            </>
          </ConfirmCommitButton>
          <Button onClick={deleteMapping}>Does Not Map</Button>
        </Box>
      </Box>
    </Box>
  )
}

function NodeCompare({
  source,
  dest,
  override,
}: {
  source: { node: INode; path: string }
  dest?: { node: INode; path: string }
  override?: { node: INode; path: string }
}) {
  return (
    <Box>
      <Box>
        <Box>Compare Titles</Box>
        <Box padding={'10px'}>
          <Box>
            <Button onClick={() => goToNode(source.node)}>
              {source.node.title}
            </Button>
          </Box>
          {[dest, override].map((node) => {
            return (
              node && (
                <Box>
                  <Button onClick={() => goToNode(node.node)}>
                    {node.node.title}
                  </Button>
                </Box>
              )
            )
          })}
        </Box>
      </Box>
      <Box>
        <Box>Compare Paths</Box>
        <Box padding={'10px'}>
          <Box>F: {source.path}</Box>
          {[dest, override].map((node) => {
            return node && <Box>T: {node.path}</Box>
          })}
        </Box>
      </Box>
    </Box>
  )
}
